<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 31.826 32.826">
        <g id="Group_2825" data-name="Group 2825" transform="translate(-24 -413)">
            <circle id="Ellipse_184" data-name="Ellipse 184" cx="14" cy="14" r="14" transform="translate(24 413)"
                    fill="#cedbff"/>
            <g id="info" transform="translate(31.174 421.174)">
                <path id="Path_70023" data-name="Path 70023"
                      d="M12.826,1C5.754,1,1,5.754,1,12.826S5.754,24.652,12.826,24.652,24.652,19.9,24.652,12.826,19.9,1,12.826,1Zm0,22.32A10.494,10.494,0,1,1,23.32,12.826,10.506,10.506,0,0,1,12.826,23.32Z"
                      fill="#799cfb"/>
                <path id="Path_70024" data-name="Path 70024"
                      d="M146.556,70a1.555,1.555,0,1,0,1.554,1.555A1.557,1.557,0,0,0,146.556,70Z"
                      transform="translate(-133.731 -64.559)" fill="#799cfb"/>
                <path id="Path_70025" data-name="Path 70025"
                      d="M151.166,140A1.166,1.166,0,0,0,150,141.166v7a1.166,1.166,0,0,0,2.332,0v-7A1.166,1.166,0,0,0,151.166,140Z"
                      transform="translate(-138.34 -129.117)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IAbout",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
